export const LinkedInHowItWorks: React.FC = () => {
  return (
    <div>
      <div>
        <ul>
          <li>
            <b>Connect LinkedIn</b>: Click <b>Connect</b> to begin setting up the integration.
          </li>
          <li>
            <b>Log in to LinkedIn</b>: Sign in using your LinkedIn account credentials.
          </li>
          <li>
            <b>Authorize Access</b>: Follow the prompts to grant Zocks the necessary permissions.
          </li>
          <li>
            <b>Complete Setup:</b> Once authorized, you’ll be redirected to Zocks, where your LinkedIn connection will appear as active.
          </li>
        </ul>
      </div>
      <div className='paragraph-medium'>You can manage or disconnect your LinkedIn account at any time from the Integrations page.</div>
    </div>
  )
}
